'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _define = require('./define');

var _define2 = _interopRequireDefault(_define);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var internal = function internal(val, fn) {
  return fn(val);
}; /**
    * Create a function which executes a function based on a defined value
    *
    * @module executeWith
    * @func
    * @since 1.11.0
    * @param {*} val
    * @param {function} fn
    * @return {function|*}
    * @example
    *
    *     const addOne = a => a + 1;
    *     executeOn(1, addOne); //=> 2
    *     executeOn(2)(addOne); //=> 3
    */

var executeOn = (0, _define2.default)(internal);

exports.default = executeOn;